import ActualLeadTime from './ActualLeadTime';

export default ActualLeadTime;
